import React, { useMemo, useState } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { OGAMilestoneTableHeader } from '../utils/OGAMilestoneTableHeader';
import StageBadge, { stageStyles } from './StageBadge';
import GlobalTableNoPagination from '../../../../../components/CustomTableWithPagination/GlobalTableNoPagination';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';

const formatCurrency = (value) => (value || value === 0 ? `₹${value.toLocaleString('en-IN')}` : '-');

const OGAMilestoneTable = ({ loading, responseData }) => {
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const rows = useMemo(() => {
    const milestones = responseData?.data?.milestones || [];

    return milestones.map((item, index) => {
      const stageStyle = stageStyles[item.currentStage] || {};
      const nextStageStyle = stageStyles[item.nextStage] || {};
      return {
        id: index,
        name: item.oga,
        wing: item.wing,
        stage: (
          <Chip
            label={`${stageStyle.emoji || ''} ${item.currentStage}`}
            sx={{
              background: stageStyle.bg || '#ccc',
              color: '#000',
              fontWeight: 600,
              my: 0.7,
            }}
          />
        ),
        totalCollection: formatCurrency(item.totalCollection),
        nextStage: (
          <Chip
            label={`${nextStageStyle.emoji || ''} ${item.nextStage}`}
            sx={{
              background: nextStageStyle.bg || '#ccc',
              color: '#000',
              fontWeight: 600,
              my: 0.7,
            }}
          />
        ),
        performanceInsights: (
          <Typography
            fontSize={13}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.4,
            }}
          >
            {item.performanceInsights ?? '-'}
          </Typography>
        ),
        currentMonthCollection: formatCurrency(item.currentMonthCollection),
        prevMonthCollection: formatCurrency(item.prevMonthCollection),
        difference: formatCurrency(item.difference),
      };
    });
  }, [responseData]);

  const noDataFound = rows.length === 0;

  const formattedColumns = OGAMilestoneTableHeader;

  return (
    <Box>
      {noDataFound && !loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30vh',
          }}
        >
          <NoDataFound />
        </Box>
      ) : (
        <GlobalTableNoPagination
          rowUniqueId="name"
          headers={formattedColumns}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={rows}
        />
      )}

      <Box mt={2} ml={2}>
        <Typography fontWeight={600} mb={1}>
          Stage Legend:
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap">
          {Object.entries(stageStyles).map(([stage, style]) => (
            <Chip
              key={stage}
              label={`${style.emoji} ${stage}`}
              sx={{
                background: style.bg,
                fontWeight: 500,
                borderRadius: '8px',
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(OGAMilestoneTable);
